import {
  LanguageActionTypes,
  LanguageKeyType,
  Languages,
  LanguageState,
} from './types';
import { CHANGE_LOCAL } from './constants';
import enLocals from '../../../lang/en';
import daLocals from '../../../lang/da';
import svLocals from '../../../lang/sv';

export const languageInitialState: LanguageState = {
  all: {
    en: enLocals,
    da: daLocals,
    sv: svLocals,
  },
  active: window.__defaultLocale__,
};

export const activeLocalReducer = (
  state: LanguageKeyType = languageInitialState.active,
  action: LanguageActionTypes,
): LanguageKeyType => {
  if (action.type === CHANGE_LOCAL) {
    return action.payload;
  }

  return state;
};

export default {
  local: activeLocalReducer,
  languages: (state: Languages = languageInitialState.all): Languages => state,
};
